module.exports = __webpack_public_path__ + "static/media/ppt.318bbb66.svg";